import { API_BASE_URL, ApiEnvelope, MediaTicket, apiClient, authHeaders } from 'service/apiClient';

const imageViewerApi = {
  async fetchImageBlob(path: string) {
    const res = await apiClient.post<Blob>(
      '/api/files/image',
      { path },
      { ...authHeaders(), responseType: 'blob' }
    );
    return res.data;
  },

  async fetchImagePreview(path: string) {
    const res = await apiClient.post<Blob>(
      '/api/files/preview',
      { path },
      { ...authHeaders(), responseType: 'blob' }
    );
    if (!res.data || res.data.size <= 0) {
      throw new Error('Empty image preview');
    }
    return res.data;
  },

  createMediaTicket(path: string) {
    return apiClient.post<ApiEnvelope<MediaTicket>>('/api/files/media-ticket', { path }, authHeaders());
  },

  revokeMediaTicket(ticket: string) {
    return apiClient
      .delete('/api/files/media-ticket', { params: { ticket }, ...authHeaders() })
      .catch(() => undefined);
  },

  filesStreamUrl(ticket: string) {
    return `${API_BASE_URL}/api/files/stream?${new URLSearchParams({ ticket })}`;
  },

  setWallpaper(path: string) {
    return apiClient.put<ApiEnvelope<null>>('/auth/wallpaper', { path }, { ...authHeaders(), timeout: 0 });
  },

  dsDelete(path: string, recursive = false) {
    return apiClient.post<ApiEnvelope<null>>(
      '/ds/delete',
      { path, recursive },
      { ...authHeaders(), timeout: 0 }
    );
  },
};

export default imageViewerApi;
